'use strict';
var LabelBuilder = /** @class */ (function () {
    function LabelBuilder() {
        this.label = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'Test Label',
            attributes: {
                color: '#0099ff'
            }
        };
    }
    LabelBuilder.prototype.withId = function (labelId) {
        this.label.id = labelId;
        return this;
    };
    LabelBuilder.prototype.withName = function (name) {
        this.label.name = name;
        return this;
    };
    LabelBuilder.prototype.withColor = function (color) {
        this.label.attributes.color = color;
        return this;
    };
    LabelBuilder.prototype.build = function () {
        return this.label;
    };
    return LabelBuilder;
}());
export { LabelBuilder };
//# sourceMappingURL=label-builder.js.map